import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Camera, Loader, X } from "lucide-react";
import Modal from "../../../components/common/Modal";

const FriendFormModal = ({
  onClose,
  newIdea,
  setNewIdea,
  handleSubmit,
  loadingSubmit,
  handleImageChange,
  handleRemoveImage,
}) => {
  const fileInputRef = useRef(null);

  const headerContent = (
    <div>
      <motion.h2
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.4 }}
        className="tw-text-2xl tw-font-bold tw-bg-gradient-to-r tw-from-gray-900 tw-to-gray-600 tw-bg-clip-text tw-text-transparent"
      >
        推薦你的朋友
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.4 }}
        className="tw-text-gray-500 tw-mt-2"
      >
        送你的朋友到煉獄 ❤️‍🔥
      </motion.p>
    </div>
  );

  return (
    <Modal onClose={onClose} headerContent={headerContent}>
      <form onSubmit={handleSubmit} className="tw-space-y-8">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.3 }}
        >
          <label className="tw-block tw-text-base tw-font-medium tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-transparent">
            你朋友的名字
          </label>
          <motion.input
            whileFocus={{ scale: 1.01 }}
            type="text"
            required
            placeholder="宋智雅"
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue] tw-transition-all"
            value={newIdea.name}
            onChange={(e) =>
              setNewIdea({
                ...newIdea,
                name: e.target.value,
              })
            }
          />
          <div className="tw-mt-8">
            <label className="tw-block tw-text-base tw-font-medium tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-transparent">
              你朋友的性別
            </label>
            <div className="tw-mt-2 tw-flex tw-gap-4">
              <label className="tw-flex tw-items-center">
                <input
                  type="radio"
                  required
                  name="gender"
                  value="male"
                  checked={newIdea.gender === "male"}
                  onChange={(e) =>
                    setNewIdea({
                      ...newIdea,
                      gender: e.target.value,
                    })
                  }
                  className="tw-mr-2"
                />
                男性
              </label>
              <label className="tw-flex tw-items-center">
                <input
                  type="radio"
                  required
                  name="gender"
                  value="female"
                  checked={newIdea.gender === "female"}
                  onChange={(e) =>
                    setNewIdea({
                      ...newIdea,
                      gender: e.target.value,
                    })
                  }
                  className="tw-mr-2"
                />
                女性
              </label>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.3 }}
        >
          <label className="tw-block tw-text-base tw-font-medium tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-transparent">
            你朋友的聯絡方式
          </label>
          <div className="tw-mt-2 tw-flex tw-w-full tw-gap-2">
            <motion.input
              whileFocus={{ scale: 1.01 }}
              type="text"
              required
              placeholder="+886"
              className="tw-block tw-w-[23%] tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue] tw-transition-all"
              value={newIdea.telegram?.split(" ")[0] || ""}
              onChange={(e) =>
                setNewIdea({
                  ...newIdea,
                  telegram: `${e.target.value} ${
                    newIdea.telegram?.split(" ")[1] || ""
                  }`,
                })
              }
            />
            <motion.input
              whileFocus={{ scale: 1.01 }}
              type="text"
              required
              placeholder="1234567890"
              className="tw-block tw-w-[77%] tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue] tw-transition-all"
              value={newIdea.telegram?.split(" ")[1] || ""}
              onChange={(e) =>
                setNewIdea({
                  ...newIdea,
                  telegram: `${newIdea.telegram?.split(" ")[0] || ""} ${
                    e.target.value
                  }`,
                })
              }
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4, duration: 0.3 }}
        >
          <label className="tw-block tw-text-base tw-font-medium tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-transparent">
            是什麼讓你的朋友如此迷人？
          </label>
          <motion.textarea
            whileFocus={{ scale: 1.01 }}
            rows={4}
            placeholder="分享一下吧 🍵"
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue] tw-transition-all"
            value={newIdea.description}
            onChange={(e) =>
              setNewIdea({
                ...newIdea,
                description: e.target.value,
              })
            }
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.3 }}
          className="tw-space-y-4"
        >
          <label className="tw-block tw-text-base tw-font-medium tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-transparent">
            上傳你朋友的可愛照片
          </label>
          <input
            type="file"
            accept="image/*"
            multiple
            ref={fileInputRef}
            onChange={handleImageChange}
            className="tw-hidden"
          />
          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
            {newIdea.imagePreviews.map((preview, index) => (
              <div key={index} className="tw-relative">
                <img
                  src={preview}
                  alt={`預覽 ${index + 1}`}
                  className="tw-w-full tw-h-48 tw-object-cover tw-rounded-xl"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveImage(index)}
                  className="tw-absolute tw-top-2 tw-right-2 tw-p-1 tw-bg-white tw-rounded-full hover:tw-bg-gray-100"
                >
                  <X className="tw-w-4 tw-h-4 tw-text-gray-500" />
                </button>
              </div>
            ))}
            <div
              onClick={() => fileInputRef.current?.click()}
              className="tw-cursor-pointer tw-relative tw-w-full tw-h-48 tw-rounded-xl tw-bg-gray-50 tw-border-2 tw-border-dashed tw-border-gray-300 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-100 tw-transition-colors"
            >
              <div className="tw-text-center">
                <Camera className="tw-w-8 tw-h-8 tw-text-gray-400 tw-mx-auto tw-mb-2" />
                <p className="tw-text-sm tw-text-gray-500">
                  點擊上傳照片
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.3 }}
          className="tw-flex tw-justify-end tw-space-x-4 tw-pt-4"
        >
          <motion.button
            whileHover={
              !loadingSubmit
                ? {
                    scale: 1.05,
                    boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
                  }
                : {}
            }
            whileTap={!loadingSubmit ? { scale: 0.95 } : {}}
            transition={{
              type: "spring",
              stiffness: 500,
              damping: 15,
            }}
            type="submit"
            disabled={loadingSubmit}
            className="tw-px-8 tw-py-3.5 tw-bg-gradient-to-r tw-from-[#ff6b6b] tw-to-pink-500 tw-text-white tw-rounded-xl tw-text-base tw-font-medium tw-shadow-lg hover:tw-shadow-xl tw-transition-all disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-flex tw-items-center tw-space-x-2"
          >
            {loadingSubmit ? (
              <>
                <Loader className="tw-w-5 tw-h-5 tw-animate-spin" />
                <span>上傳中...</span>
              </>
            ) : (
              <span>推薦你的朋友</span>
            )}
          </motion.button>
        </motion.div>
      </form>
    </Modal>
  );
};

export default FriendFormModal;
